import React, { useEffect, useState, useContext } from "react";
import { Parser } from 'html-to-react'
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import AlternateEmailRoundedIcon from '@mui/icons-material/AlternateEmailRounded';
import SettingsSuggestOutlinedIcon from '@mui/icons-material/SettingsSuggestOutlined';
import TaskAltOutlinedIcon from '@mui/icons-material/TaskAltOutlined';
import LocalizationContext from "../LocalizationContext";

export const FeedbackAlert = (props) => {
    const localizationCtx = useContext(LocalizationContext);

    const [open, setOpen] = useState(props.open);
    const [duration, setDuration] = useState(2000);

    useEffect(() => {
        setOpen(props.open);
        if (props.severity === "config-success") {
            setDuration(200000);
        } else {
            setDuration(2000);
        }
    }, [props.open, props.severity])

    const handleClose = () => {
        setOpen(false);
        props.closedCallback();
    };

    const handleSendConfiguration = () => {
        setOpen(false);
        props.actionCallback(2);
    }

    const withExtendedSuccess = (
        <div className="box-alert-container">

            <div className="row my-2">
                <div className="col-12 text-center d-flex align-items-center">
                    <TaskAltOutlinedIcon style={{ color: 'white' }} />
                    <p className="text-alert-success">&nbsp;&nbsp;{props.text}</p>
                </div>
            </div>
            <div className="row my-2">
                <div className="col-12 col-lg-6 text-center">
                    <a className="flat-white-button text-uppercase mt-2" onClick={handleSendConfiguration}>{Parser().parse(localizationCtx.localizationData.buttonSend)}</a>
                </div>
                <div className="col-12 col-lg-6 text-center">
                    <a className="flat-white-button text-uppercase mt-2" onClick={handleClose}>{Parser().parse(localizationCtx.localizationData.buttonContinue)}</a>
                </div>
            </div>
        </div>
    );

    const withError = (
        <Alert
            onClose={handleClose}
            severity={props.severity}
            sx={{ width: "100%" }}
            elevation={6}
            variant="filled"
        >
            {props.text}
        </Alert>
    );

    const withSuccess = (
        <Alert
            onClose={handleClose}
            severity={props.severity}
            sx={{ width: "100%" }}
            elevation={6}
            variant="filled"
        >
            {props.text}
        </Alert>
    );

    const setAction = () => {
        if (props.severity === "success") {
            return withSuccess;
        }

        if (props.severity === "error") {
            return withError;
        }

        if (props.severity === "config-success") {
            return withExtendedSuccess;
        }
    }

    return (
        <Snackbar
            open={open}
            autoHideDuration={duration}
            onClose={handleClose}
            anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
            action={setAction()}
        >
        </Snackbar>
    );
};
export default FeedbackAlert;